import { DueDate } from '../types';

export function transformCalendarDueDates(dueDates: DueDate[]) {
	return dueDates.map((dd) => ({
		...dd,
		penaltyFactor: Math.round(dd.penaltyFactor * 100),
		penaltyPeriodLength: Math.round(dd.penaltyPeriodLength / 86400)
	}));
}
